// src/helper/ProtectedRoute.jsx
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ isAuthenticated, element }) => {
  // "";
  return isAuthenticated ? element : <Navigate to={`/admin/authenticate`} />;
};

export default ProtectedRoute;
